// frontend/src/components/UI/LoadingSpinner.jsx
import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({ 
    size = 'default', 
    text = 'Loading...', 
    className = '',
    textClassName = ''
}) => {
    const sizeClasses = {
        small: 'h-4 w-4',
        default: 'h-5 w-5',
        large: 'h-6 w-6'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <Loader 
                className={`animate-spin ${sizeClasses[size]} ${text ? 'mr-2' : ''}`} 
                aria-hidden="true"
            />
            {text && (
                <span className={`text-sm text-gray-700 ${textClassName}`}>
                    {text}
                </span>
            )}
        </div>
    );
};

export default LoadingSpinner;
